import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import { Generic2FieldForm } from '.';

type PreviewProps = {
    test: Test
}

export class Generic2FieldRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <Generic2FieldForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}